import { render, staticRenderFns } from "./TravelPolicyBuilder.vue?vue&type=template&id=3ffbbe63&scoped=true&"
import script from "./TravelPolicyBuilder.vue?vue&type=script&lang=js&"
export * from "./TravelPolicyBuilder.vue?vue&type=script&lang=js&"
import style0 from "./TravelPolicyBuilder.vue?vue&type=style&index=0&lang=css&"
import style1 from "./TravelPolicyBuilder.vue?vue&type=style&index=1&id=3ffbbe63&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ffbbe63",
  null
  
)

export default component.exports